import React from 'react'
import { View, StyleSheet, Image, Text, Dimensions, ImageSourcePropType, LayoutChangeEvent } from 'react-native'
import Chair from '../../assets/VMBCH-CR-T0-A1-CF-CC-8613.png'

type HeaderPropTypes = {
  /** Called when the function is layed out to measure the header height. */
  onLayout: (event: LayoutChangeEvent) => void,
}

const Header = ({onLayout}: HeaderPropTypes) => {
  return (
    <View style={styles.header}
      onLayout={onLayout}
    >
      <Image
        style={styles.chair}
        resizeMode={'contain'}
        source={Chair as ImageSourcePropType}
        height={Dimensions.get('window')?.height > 800 ? 400 : Dimensions.get('window')?.height < 100 ? 400 : 200}
      >
      </Image>
      <View style={styles.textContainer}>
        <Text style={styles.title}>Build A Chair</Text>
        <Text style={styles.paragraph}>Scroll to begin the configurator and find the perfect chair</Text>
      </View>
    </View>
  )
}

export default Header

const styles = StyleSheet.create({
  header: {
    width: '100%',
    flex: 1,
  },
  chair: {
    flex: 1,
    height: Dimensions.get('window')?.height > 800 ? 400 : 200,
    width: '100%',
    marginBottom: 40,
    marginLeft: 0,
    marginRight: 0,
  },
  textContainer: {
    display: 'flex',
    alignItems: 'center',
    flex: 1,
  },
  logo: {
    width: '70%',
    height: 60,
    margin: 20,
  },
  title: {
    margin: 5,
    fontSize: 48,
    fontWeight: 'bold',
  },
  subTitle: {
    margin: 5,
    fontSize: 36,
  },
  paragraph: {
    margin: 5,
    fontSize: 24,
    fontWeight: '500',
    color: 'gray',
    maxWidth: '90%',
    textAlign: 'center',
  },
  carrot: {
    margin: 20,
    height: 40,
    width: 40,
  },
})